
// 辅助：从 'rgb(r,g,b)' 或 '#rrggbb' 中解析出 [r, g, b]
function parseRGB(color) {
  // 如果是 rgb(...) 格式
  const rgbMatch = color.match(/^rgb\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*\)$/i);
  if (rgbMatch) {
    return rgbMatch.slice(1, 4).map(Number);
  }
  // 如果是十六进制 #rrggbb
  const hexMatch = color.match(/^#?([a-f\d]{6})$/i);
  if (hexMatch) {
    const intVal = parseInt(hexMatch[1], 16);
    return [
      (intVal >> 16) & 0xff,
      (intVal >> 8) & 0xff,
      intVal & 0xff,
    ];
  }
  // fallback
  return [0, 0, 0];
}

// 计算相对亮度，范围 0（最暗）–1（最亮）
// 公式来源于 WCAG：https://www.w3.org/TR/WCAG20-TECHS/G17.html
export const getLuminance =(color) => {
  const [r, g, b] = parseRGB(color).map((v) => {
    // 转为 0-1
    const c = v / 255;
    // 线性化
    return c <= 0.03928
      ? c / 12.92
      : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  // 加权并返回
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

const CONTRAST_THRESHOLD = 0.45;
const NEAR_BLACK = 'rgb(17,24,39)';
const NEAR_WHITE = 'rgb(255,255,255)';

function hasEnoughContrast(color, backgroundColor) {
  return !!color && Math.abs(getLuminance(color) - getLuminance(backgroundColor)) >= CONTRAST_THRESHOLD;
}

// Last-resort safety net: whichever of near-black/near-white contrasts
// better against backgroundColor. Used only when neither the admin's
// candidate color NOR the caller's suggested fallback are actually
// readable against the current background - a fixed fallback (e.g. always
// dark grey) is itself just another color that can fail against a dark
// custom background, so the true last resort has to be background-aware
// too, not a second static color.
function bestContrastColor(backgroundColor) {
  const bgLuminance = getLuminance(backgroundColor);
  const blackContrast = Math.abs(getLuminance(NEAR_BLACK) - bgLuminance);
  const whiteContrast = Math.abs(getLuminance(NEAR_WHITE) - bgLuminance);
  return whiteContrast > blackContrast ? NEAR_WHITE : NEAR_BLACK;
}

// Picks candidateColor if it has enough luminance contrast against
// backgroundColor; otherwise tries fallbackColor (same check); otherwise
// falls all the way back to a dynamically-chosen black/white. Use this any
// time a theme-configurable text/icon color is painted onto a
// theme-configurable background - two independently admin-picked colors
// can otherwise land on the same side of light/dark and become unreadable
// (this happened in TopTabs.js's contact drawer, where the "custom theme"
// branch used the admin's color with no safety check at all). The
// three-tier fallback additionally covers the case where even the
// caller's suggested fallback color doesn't suit the actual background
// (e.g. a fixed dark-grey fallback against a dark custom drawer
// background) - only a background-aware last resort is guaranteed safe.
export const resolveReadableColor = (candidateColor, backgroundColor, fallbackColor) => {
  if (hasEnoughContrast(candidateColor, backgroundColor)) return candidateColor;
  if (hasEnoughContrast(fallbackColor, backgroundColor)) return fallbackColor;
  return bestContrastColor(backgroundColor);
}
